<template>
  <ValidationObserver ref="validate">
    <div>
      <div class="form-card">
        <h3 class="form-card-title">
          <span
            class="title-text"
          >{{ Getter_User_Info.paymentPasswordStatus == 0 ? $t('labels.acc.txnPwd.setup') : $t('labels.acc.txnPwd.modify') }}</span>
          <span class="explain">
            <i class="star">*</i>
            {{ $t('labels.acc.txnPwd.desc2') }}
          </span>
        </h3>
        <div class="form-card-body">
          <div class="form">
            <p class="color-error mb-10" v-if="Getter_User_Info.gaStatus === 0">
              {{ $t('labels.acc.ga.txt.1') }}
              <router-link
                to="/usercenter/google-verification-bind"
                class="text-bold color-error"
              >{{ $t('labels.acc.ga.setup') }}</router-link>
            </p>
            <div class="hidden-input">
              <input type="password" />
            </div>
            <div v-if="Getter_User_Info.paymentPasswordStatus == 0">
              <div class="form-group">
                <TextFieldComponent
                  type="password"
                  :model.sync="form.payPassword"
                  :rules="rules.payPassword"
                  :label="$t('labels.acc.txnPwd')"
                  :outlined="true"
                  :vid="'payPassword'"
                ></TextFieldComponent>
              </div>
              <div class="form-group">
                <TextFieldComponent
                  type="password"
                  :model.sync="form.reqPayPassword"
                  :rules="{ ...rules.reqPayPassword, confirmed: 'payPassword' }"
                  :label="$t('labels.acc.confirmTxnPwd')"
                  :outlined="true"
                ></TextFieldComponent>
              </div>
            </div>
          </div>
          <div v-if="Getter_User_Info.paymentPasswordStatus == 1">
            <div class="form-group">
              <TextFieldComponent
                type="password"
                :model.sync="form.oldPassword"
                :rules="{ ...rules.oldPassword, not_same: form.newPassword }"
                :label="$t('labels.acc.txnPwd.old')"
                :outlined="true"
              ></TextFieldComponent>
            </div>
            <div class="form-group">
              <TextFieldComponent
                type="password"
                :model.sync="form.newPassword"
                :rules="rules.newPassword"
                :label="$t('labels.acc.txnPwd.new')"
                :outlined="true"
                :vid="'newPassword'"
              ></TextFieldComponent>
            </div>
            <div class="form-group">
              <TextFieldComponent
                type="password"
                :model.sync="form.reNewPassword"
                :rules="{ ...rules.reNewPassword, confirmed: 'newPassword' }"
                :label="$t('labels.acc.txnPwd.confirmNew')"
                :outlined="true"
              ></TextFieldComponent>
            </div>
          </div>
          <!-- <div class="form-group" v-if="Getter_User_Info.enablePhoneCheck === 1">
          <div class="color-666 text-right mb-5">{{Getter_User_Info.phoneNo}}</div>
          <div class="verify-wrap">
            <q-field
              class="quasar-qfield glay-bg secret-key-input"
              :error="$v.form.phoneCode.$error"
              :error-label="getErrorLabel($v.form.phoneCode, 'phoneCode')">
              <q-input
                v-model="form.phoneCode"
                @blur="$v.form.phoneCode.$touch"
                :class="{'invalid-class': $v.form.phoneCode.$error}"
                :float-label="'手机验证码'" />
            </q-field>

            <VerifyBtn class="verify-btn"
                       :type="'phone'"
                       :value="Getter_User_Info.phoneNo"
                       :country-code="Getter_User_Info.phoneCode"></VerifyBtn>
          </div>
          </div>-->
          <!-- <div class="form-group" v-if="Getter_User_Info.enableEmailCheck === 1">
          <div class="color-666 text-right mb-5">{{Getter_User_Info.email}}</div>
          <div class="verify-wrap">
            <q-field
              class="quasar-qfield glay-bg secret-key-input"
              :error="$v.form.emailCode.$error"
              :error-label="getErrorLabel($v.form.emailCode, 'emailCode')">
              <q-input
                v-model="form.emailCode"
                @blur="$v.form.emailCode.$touch"
                :class="{'invalid-class': $v.form.emailCode.$error}"
                :float-label="'邮箱验证码'" />
            </q-field>

            <VerifyBtn class="verify-btn"
                       :type="'email'"
                       :value="Getter_User_Info.email"
                       :country-code="''"></VerifyBtn>
          </div>
          </div>-->
          <div class="form-group">
            <TextFieldComponent
              type="password"
              :model.sync="form.gaCode"
              :rules="rules.gaCode"
              :label="$t('labels.gaCode')"
              :outlined="true"
            ></TextFieldComponent>
          </div>
          <div class="form-group">
            <v-btn
              class="commit-btn"
              depressed
              @click="submitBtnClick"
              :loading="committing"
            >{{Getter_User_Info.paymentPasswordStatus == 0 ? $t('actions.submit') : $t('actions.modify')}}</v-btn>
          </div>
          <div
            class="color-error"
            style="font-size: 12px; margin-top: 5px;"
          >*{{$t('v.common.txnPwd.format.note')}}</div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import index from './traders-pwd-bind';
export default index;
</script>

<style src="@/common/styles/mixin/account-bind.scoped.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
@import 'traders-pwd-bind.scoped.styl';
</style>
